import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { AuthShell } from "./ForgotPassword";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords do not match");
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, password: pw });
      toast.success(data.message);
      nav("/login");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <h2 className="text-2xl font-extrabold tracking-tight">Set a new password</h2>
      <p className="mt-1 text-sm text-slate-500">Choose a password with at least 6 characters.</p>
      {!token ? (
        <div className="mt-6 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="reset-missing-token">Reset link is missing or invalid.</div>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <Input data-testid="reset-password-input" type="password" required minLength={6} placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-11" />
          <Input data-testid="reset-confirm-input" type="password" required placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-11" />
          {error && <div data-testid="reset-error" className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
          <Button data-testid="reset-submit-btn" type="submit" disabled={busy} className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-slate-900" data-testid="reset-back-to-login">
        <ArrowLeft className="h-4 w-4" /> Back to sign in
      </Link>
    </AuthShell>
  );
}
